import { render, staticRenderFns } from "./midlist.vue?vue&type=template&id=51f1c486&scoped=true&"
import script from "./midlist.vue?vue&type=script&lang=js&"
export * from "./midlist.vue?vue&type=script&lang=js&"
import style0 from "./midlist.vue?vue&type=style&index=0&id=51f1c486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f1c486",
  null
  
)

export default component.exports